import DOMPurify, { Config } from 'isomorphic-dompurify';

const purifyHtml = (html: string, options?: Config) => {
  return DOMPurify.sanitize(html, options);
};

export default purifyHtml;
